import { TicketStatusCard } from '@/ui-components/components/TicketStatusCard'
import usePollTab, { TabType } from './usePollTab'
import Pagination from '@/ui-components/components/Pagination'
import EmptyTicket from '@/ui-components/components/TicketStatusCard/EmptyTicket'
import { DotsLoading } from '@/ui-components/components/Loading'

import { useThemeFeatures } from '@/ui-components/hooks/useThemeFeatures'

type PollTabProps = { tabType: TabType }

const PollTab = ({ tabType }: PollTabProps) => {
  const {
    tickets,
    currentPage,
    totalPages,
    onPageChange,
    loading,
    dialogComponent,
  } = usePollTab(tabType)
  const themeFeatures = useThemeFeatures()
  return (
    <>
      {dialogComponent}
      <div className="w-full my-8">
        {loading && <DotsLoading size="md" />}
        {tickets?.length === 0 && !loading && <EmptyTicket />}
        <div
          className={`w-full ${
            themeFeatures.ticketGridColumns === 2
              ? 'grid grid-cols-1 sm:grid-cols-1 lg:grid-cols-2 gap-4'
              : 'flex flex-col gap-4'
          }`}
        >
          {tickets?.map((ticket) => (
            <TicketStatusCard
              key={ticket.ticketNumber}
              ticketNumber={ticket.ticketNumber}
              betDate={ticket.betDate}
              listTitle={ticket.listTitle}
              drawDate={ticket.drawDate}
              amount={ticket.amount}
              winAmount={ticket.winAmount}
              status={ticket.status}
              onViewClick={ticket.onViewClick}
              canCancel={ticket.canCancel}
              onCancel={ticket.onCancel}
              isPrimary={ticket.isPrimary}
              bonus={ticket.bonus}
            />
          ))}
        </div>
      </div>
      {totalPages > 1 && (
        <Pagination
          currentPage={currentPage}
          totalPages={totalPages}
          onPageChange={onPageChange}
        />
      )}
    </>
  )
}

export default PollTab
